module.exports = __webpack_public_path__ + "static/media/Vinu sha.7223c784.jpg";